import { PartResponse, PartsImage } from "../../pages/parts/PartInfo/types";
import axios from "../api";
import {
  AlternatePart,
  AlternativePartsResponse,
  PartAsset,
  PartAssetsResponse,
  PartsLocaleResponse,
  PartsSearchRequest,
  PartsSearchResponse,
} from "./types";

const partsApi = {
  getPartsImage: (
    partsServiceUrl: string,
    partNumber: string,
    location: string,
    accessToken: string
  ): Promise<PartsImage> =>
    axios
      .getWithRetries(`${partsServiceUrl}/parts/v1/image`, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params: { countryCode: location, partNumber },
      })
      .then((response: any) => response.data),

  search: (
    partsServiceUrl: string,
    accessToken: string,
    body: PartsSearchRequest
  ): Promise<PartResponse[]> =>
    axios
      .postWithRetries<PartsSearchResponse>(
        `${partsServiceUrl}/parts/v1/search`,
        { ...body },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((response: any) => response.data.parts),

  searchWithLocale: (
    partsServiceUrl: string,
    accessToken: string | undefined,
    body: PartsSearchRequest
  ): Promise<PartsLocaleResponse[]> =>
    axios
      .postWithRetries<PartsLocaleResponse>(
        `${partsServiceUrl}/parts/v1/search/locale`,
        body,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((response: any) => response.data.partLocales)
      .catch((error) => Promise.reject(error)),

  getAssets: (
    url: string,
    token: string,
    partNumber: string,
    location: string
  ): Promise<PartAsset[]> =>
    axios
      .getWithRetries<PartAssetsResponse>(`${url}/parts/v1/assets`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { countryCode: location, partNumber },
      })
      .then((res) => res.data.assets),

  getAlternativeParts: (
    partsServiceUrl: string,
    accessToken: string,
    countryCode: string,
    accountId: string,
    partNumber: string
  ): Promise<AlternatePart[]> =>
    axios
      .getWithRetries<AlternativePartsResponse>(
        `${partsServiceUrl}/alternative-parts/v1/${countryCode}/${accountId}/${partNumber}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((res) => res.data.relations?.alternates ?? []),
};

export default partsApi;
